// @owners { team: patients }
import { useCallback } from 'react';
import { updateOrder } from '~shared/actions/checkout';
import { getOrderTipAmount } from '~shared/features/checkout/selectors/getOrder';
import { getTipAmountWithDefault } from '~shared/features/courier-tips/helpers';
import { useDispatchShared, useSelectorShared } from '~shared/store';

/** Reads and updates checkout tip amount from Redux. */
export const useCheckoutTipControls = () => {
  const dispatch = useDispatchShared();
  const orderTipAmount = useSelectorShared(getOrderTipAmount);

  const onTipAmountChange = useCallback(
    (tipAmount: number | undefined) => {
      if (orderTipAmount !== tipAmount) {
        dispatch(updateOrder({ tip_amount: tipAmount }));
      }
    },
    [dispatch, orderTipAmount],
  );

  return {
    orderTipAmount,
    tipAmount: getTipAmountWithDefault(orderTipAmount), // tip amount displayed in CourierTipInput
    onTipAmountChange,
  };
};
